export default {
  placeholderApiUrl: "https://coffee-capsules.ninjasforjava.com/rest",
};

// https://coffee-capsules.ninjasforjava.com/